import { CommonTopographicCodeResponse } from '@/api/services/common/topographic-code/common-topographic-code.dto'
import { ConfigurationPersonnelTopographicCodeAssignmentResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-topographic-code-assignment/configuration-personnel-topographic-code-assignment.dto'
import { store } from '@/store/store'

export interface ConfigurationAutomationPersonnelEntitiesAssociationModalTopographicCodeAssignmentFormState {
    topographicCodes: CommonTopographicCodeResponse[]
    personnelTopographicCodeAssignments: ConfigurationPersonnelTopographicCodeAssignmentResponse[]
    laboratoryId: number
}
export const initialConfigurationAutomationPersonnelEntitiesAssociationModalTopographicCodeAssignmentFormState =
    (): ConfigurationAutomationPersonnelEntitiesAssociationModalTopographicCodeAssignmentFormState => ({
        topographicCodes: [],
        personnelTopographicCodeAssignments: [],
        laboratoryId: store.getters.labId
    })
